
import zhizhen from '@/assets/zanzanwodeguo/zhuanpan-zhizhen.png'
import zhizhenGray from '@/assets/zanzanwodeguo/zhuanpan-zhizhen-gray.png'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import { getaddlog } from '@/api/hgfw'
import { award, isAward } from '@/api/lottery'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'

import { addCreditParty, relation, view } from '@/api/jfhl.js'
import { getUserItem } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton
},
data () {
return {
zhizhen: zhizhen,
times: '', // 答题次数
lotid: 0,
showOpen: false,
openbg: openbg,
prize: '',
start_rotating_degree: 0, // 初始旋转角度
rotate_angle: 0, // 将要旋转的角度
rotate_transition: 'transform 6s ease-in-out', // 初始化选中的过度属性控制
rotate_transition_pointer: 'transform 10s ease-in-out', // 初始化指针过度属性控制
click_flag: true, // 是否可以旋转抽奖
partyid: this.$route.params.partyid,
partyuserid: this.$route.params.partyuserid,
prizelist: [], // 奖品列表
isAward: 1, // 是否中奖
angle: '', // 转动角度
jiangpin: '', // 抽中奖品
isclick: false,
zjlist: [],
animate: false,
startTime: '',
endTime: ''
}
},
created () {
this.getAdd()
this.getview()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
top () {
return -this.activeIndex * 30 + 'px'
}
},
methods: {

isCurrentTime (beginTime, endTime) {
var that = this
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.start = 1
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '抽奖活动还未开始',
onHide () {
that.$router.push({ name: 'lajifenleiIndex', params: { partyid: this.partyid } })
}
})
return false
}
if (currentTime >= endTime) {
this.start = 1
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '抽奖活动已结束',
onHide () {
that.$router.push({ name: 'lajifenleiIndex', params: { partyid: this.partyid } })
}
})
return false
}
},

getOtherZJ () {
this.zjlist = []
getUserItem({
openid: '',
lotid: this.lotid
}).then(res => {
res.obj.items.forEach((item, index) => {
if (index < 21) {
this.zjlist.push(item)
}
})

setInterval(this.scroll, 5000)
})
},
scroll () {
let con1 = this.$refs.con1
con1.style.marginTop = '-30px'
this.animate = !this.animate
var that = this 
setTimeout(function () {
that.zjlist.push(that.zjlist[0])
that.zjlist.shift()
con1.style.marginTop = '0px'
that.animate = !that.animate 
}, 1500)
},
gorule () {
this.$router.push({ name: 'lajifenleiRule' })
},
getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120105
}).then(res => {
})
},
getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.getOtherZJ()
this.getWinning()
this.isawardNow()
this.isCurrentTime(this.startTime, this.endTime)
})
},
go () {
if (!this.isclick) {

if (this.isAward !== 2) {
this.isaward()
this.isclick = true
}
}
},

isawardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.isaward === 1 && data.obj.iszhongjiang === 1) {
this.zhizhen = zhizhenGray
this.isAward = 2
this.$vux.toast.text('今天您已经抽过奖')
} else {
this.zhizhen = zhizhen
}
})
},

isaward () {
award({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.success) {
this.isAward = data.obj.isaward
this.angle = data.obj.angle
this.prize = data.obj.item
if (data.obj.item.indexOf('积分') != -1) {
this.addIntegral(data.obj.item.replace(/[^0-9]/ig, ''))
}
this.first = false
this.rotating(this.angle)

relation({
partyuserid: this.partyuserid,
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => { })
if (data.obj.isaward === 2) {
this.zhizhen = zhizhenGray
}
}
})
},
rotating (degree) {
var type = 0 
var during_time = 5 
var rand_circle = 6 
if (type == 0) {

var rotate_angle = this.start_rotating_degree + rand_circle * 360 + degree 
this.start_rotating_degree = rotate_angle
this.rotate_angle = 'rotate(' + rotate_angle + 'deg)'
var that = this

setTimeout(() => {
this.winning()
}, during_time * 1000)
}
},
getWinning () {
getUserItem({
openid: this.userid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},
winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},
close () {
this.showOpen = false
this.isclick = true
this.zhizhen = zhizhenGray
this.isAward = 2
this.getWinning()
this.getOtherZJ()
},
addIntegral (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {
})
}
}
}
